import React from "react"
import PropTypes from "prop-types"
import { StyledP } from "./styles"

const P = ({ children, ...rest }) => <StyledP {...rest}>{children}</StyledP>

P.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(["default", "small", "medium", "large", "extralarge"]),
  variant: PropTypes.oneOf(["default", "primary", "secondary", "content", "contentv2", "secondaryReadable", "neutral"]),
  marginless: PropTypes.bool,
  bold: PropTypes.bool,
  inline: PropTypes.bool,
  align: PropTypes.oneOf(["left", "center", "right"]),
  wrap: PropTypes.bool,
  multiline: PropTypes.bool
}

P.defaultProps = {
  size: "default",
  variant: "default",
  marginless: false,
  bold: false,
  inline: false,
  align: "left",
  wrap: false,
  multiline: false
}

export default P
